export default {"src":"/_next/static/image/public/images/flags/flag_238.4ef1499e60052b27a84f5140f7efe0e9.svg","height":16,"width":24};